import tw from "twin.macro";

export const PageContainer = tw.div`sm:ml-8 p-4 sm:p-8`;
export const PageHeader = tw.header`pb-5`;
export const PageTitle = tw.h1`text-3xl font-bold`;
export const PageSubTitle = tw.p`mt-2 text-base text-gray-700`;

export const PageContent = tw.section`flex flex-col gap-4`;
export const ContentTitle = tw.h2`text-xl font-bold`;
